import { pluralize } from "@common/helpers/string";
import { AddMemberFormSchema } from "./types";

export function buildInviteMemberPayload(value: AddMemberFormSchema) {
    return {
        emails: value.emails,
        role: value.workspaceRole,
        entityAssignments: Object.keys(value.entityAssignments)
            .map(Number)
            .filter((entityId) => value.entityAssignments[entityId]),
        assignToNewEntities: value.assignToNewEntities,
    };
}

export function getInviteSentMessage(emails: string[]): string {
    return `${pluralize("Invite", emails.length)} sent to ${emails.join(", ")}.`;
}
